import { 
  PhotoUploadClient, 
  AccessCode,
  PhotoUploadVehicle,
  PhotoUploadVehicleMediaProgress 
} from '../photos'
import { 
  FirestoreDataConverter, 
  DocumentSnapshot, 
  SnapshotOptions, 
  WithFieldValue 
} from 'firebase/firestore'

// Access Code Converter
export const accessCodeConverter: FirestoreDataConverter<AccessCode> = {
  toFirestore(accessCode: WithFieldValue<AccessCode>) {
    const { id, ...data } = accessCode
    return {
      ...data,
      createdAt: data.createdAt || new Date().toISOString(),
      expires: data.expires || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
      vehicles: data.vehicles || []
    }
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): AccessCode {
    const data = snapshot.data(options)
    
    if (!data) {
      return {
        id: snapshot.id,
        code: '',
        createdAt: new Date().toISOString(),
        expires: new Date().toISOString(),
        vehicles: [],
        photoUploadId: ''
      }
    }

    return {
      id: snapshot.id,
      code: data.code || '',
      createdAt: data.createdAt || new Date().toISOString(),
      expires: data.expires || new Date().toISOString(),
      userId: data.userId || undefined,
      vehicles: data.vehicles || [],
      photoUploadId: data.photoUploadId || undefined
    }
  }
}

// Photo Upload Client Converter
export const photoUploadClientConverter: FirestoreDataConverter<PhotoUploadClient> = {
  toFirestore(photoUpload: WithFieldValue<PhotoUploadClient>) {
    const { id, ...data } = photoUpload
    return {
      ...data,
      role: 'client',
      dateCreated: data.dateCreated || new Date().toISOString(),
      status: data.status || 'Not submitted',
      submissionCount: data.submissionCount || 0,
      vehicles: data.vehicles || [],
      vehicleIds: data.vehicleIds || [],
      userId: data.userId || '',
      accessCode: data.accessCode,
      expiresAt: data.expiresAt || new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString()
    }
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): PhotoUploadClient {
    const data = snapshot.data(options)
    
    if (!data) {
      return {
        id: snapshot.id,
        role: 'client',
        status: 'Not submitted',
        submissionCount: 0,
        dateCreated: new Date().toISOString(),
        vehicles: [],
        userId: '',
        vehicleIds: [],
        accessCode: '',
        expiresAt: new Date().toISOString()
      }
    }

    return {
      id: snapshot.id,
      role: 'client',
      status: data.status || 'Not submitted',
      submissionCount: data.submissionCount || 0,
      dateCreated: data.dateCreated || new Date().toISOString(),
      vehicles: data.vehicles || [],
      preDeliverySubmissions: data.preDeliverySubmissions,
      postDeliverySubmissions: data.postDeliverySubmissions,
      userId: data.userId || '',
      email: data.email,
      phone: data.phone,
      vehicleIds: data.vehicleIds || [],
      totalVehicles: data.totalVehicles,
      submittedVehiclesCount: data.submittedVehiclesCount,
      overallPercentage: data.overallPercentage,
      progressLabel: data.progressLabel,
      accessCode: data.accessCode || '',
      expiresAt: data.expiresAt || new Date().toISOString()
    }
  }
}

// Photo Submission Item interfaces for client uploads
export interface PhotoSubmissionItem {
  id: string
  photoUploadId: string
  vehicleId: string
  angle: string
  userId: string
  uploadedAt: string
  storagePath: string
  uploadedBy: 'guest' | 'user'
}

// Photo Submission Item Converter
export const photoSubmissionItemConverter: FirestoreDataConverter<PhotoSubmissionItem> = {
  toFirestore(photoItem: WithFieldValue<PhotoSubmissionItem>) {
    const { id, ...data } = photoItem
    return {
      ...data,
      uploadedAt: data.uploadedAt || new Date().toISOString(),
      uploadedBy: data.uploadedBy || 'guest'
    }
  },
  fromFirestore(snapshot: DocumentSnapshot, options: SnapshotOptions): PhotoSubmissionItem {
    const data = snapshot.data(options)
    
    if (!data) {
      return {
        id: snapshot.id,
        photoUploadId: '',
        vehicleId: '',
        angle: '',
        userId: '',
        uploadedAt: new Date().toISOString(),
        storagePath: '',
        uploadedBy: 'guest'
      }
    }

    return {
      id: snapshot.id,
      photoUploadId: data.photoUploadId || '',
      vehicleId: data.vehicleId || '',
      angle: data.angle || '',
      userId: data.userId || '',
      uploadedAt: data.uploadedAt || new Date().toISOString(),
      storagePath: data.storagePath || '',
      uploadedBy: data.uploadedBy || 'guest'
    }
  }
}
